import React from 'react';
//import { useCallback } from 'react';
import { useContext } from 'react';
//import { Route } from 'react-router';
import { UserContext } from '../contexts/user-context';
import { useEffect } from 'react';

export const Logout = function() {
    const userContext = useContext(UserContext);
    useEffect(() => {
        userContext.doLogout();
      }, [userContext]);
    return null;
//    return <Route path="/logout" exact={true} render={doLogout} />;
}
